import { bindServices } from '@/services/api';
import { toPaginate } from '@/utils/infrastructure';

const api = bindServices('configCustomListSetup');

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const relations = {
  list: [],
  pagination: meta,
  searchCriteria: null,
  isActive: '',
  orderBy: '',
};

const initialState = {
  list: [],
  relations,
  orderBy: '',
  pagination: meta,
  currentField: null,
  activeTab: 'fields',
  view: 'add',
  deleted: false,
  searchCriteria: null,
  isActive: '',
  select: 'id,order,displayText,type,isFilterEnabled',
  notSelectSearch: 'order,isFilterEnabled,type',
  expand: {
    form: { select: 'name' },
    field: { select: 'displayText' },
    variable: { select: 'internalName' },
  },
};

const Model = {
  namespace: 'listSetup',
  state: initialState,
  effects: {
    *fetchFields({ payload }, { call, put }) {
      try {
        yield put({ type: 'loading', payload: true });
        const response = yield call(api.getAll, {
          route: 'customListField/paged',
          params: payload,
        });
        const { type, limit, page } = payload;
        yield put({ type, payload: { ...response, limit, page } });
      } catch (e) {
        /*  */
      }
    },

    *setActiveTab({ payload }, { put }) {
      yield put({ type: 'updateTab', payload });
    },

    *search({ payload }, { put }) {
      const { type, str } = payload;
      yield put({ type, payload: str });
    },

    *showAddForm({ payload }, { put }) {
      yield put({ type: 'addForm', payload });
    },

    *hideAllForms(o, { put }) {
      yield put({ type: 'hideForms' });
    },

    *setOrderBy({ payload }, { put }) {
      const { type, value } = payload;
      yield put({ type, payload: value });
    },

    *isActive({ payload }, { put }) {
      const { type, value } = payload;
      yield put({ type, payload: value });
    },
  },

  reducers: {
    loading(state, { payload }) {
      return { ...state, loading: payload };
    },

    queryFields(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        loading: false,
        pagination: {
          ...state.pagination,
          ...payload,
          ...toPaginate(payload),
        },
      };
    },

    queryEntityField(state, { payload }) {
      return {
        ...state,
        currentField: payload.item,
      };
    },

    deleted(state) {
      return {
        ...state,
        deleted: true,
      };
    },

    fieldsOrderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
        newField: false,
        currentField: null,
      };
    },

    relationsOrderBy(state, { payload }) {
      return {
        ...state,
        relations: {
          ...state.relations,
          orderBy: payload,
        },
        newField: false,
        currentField: null,
      };
    },

    updateTab(state, { payload }) {
      return {
        ...state,
        activeTab: payload,
        newField: false,
        currentField: null,
      };
    },

    searchFields(state, { payload }) {
      return {
        ...state,
        searchCriteria: payload,
      };
    },

    addForm(state, { payload }) {
      return {
        ...state,
        view: payload.view,
        newField: payload.state,
        currentField: null,
      };
    },

    stateFields(state, { payload }) {
      return {
        ...state,
        isActive: payload,
      };
    },

    hideForms() {
      return initialState;
    },
  },
};

export default Model;
